import { Action, createReducer, on } from '@ngrx/store';
import * as allActions from './dashboard.actions';

export const dashboardFeatureKey = 'dashboard';

export interface DashboardState {
    products: any;
    limit: number;
    totalItems: number;
    reloadRequired: boolean;

}

export const initialState: DashboardState = {
    products: [],
    limit: 0,
    totalItems: 0,
    reloadRequired: true,

};

export const dashboardReducer = createReducer(
    initialState,
    on(allActions.setDashboardProducts, (state: DashboardState, data) => {
        return {
            ...state,
            products: JSON.parse(JSON.stringify(data.products)),
            limit: data.limit,

            totalItems: data.totalItems,
        };
    }),

    on(allActions.setProductsReloadRequired, (state: DashboardState, data) => {
        return {
            ...state,
            reloadRequired: data?.reloadRequired,
        };
    }),


);

